export default {
  usersList: [],
  usersGroupsList: [],
  newGroups: [],
  totalPages: [],
  totalElements: [],
  current_page: 0,  
  groupAssignment: {
        name: '',
        group_name: '',
    }  
}




// WEBPACK FOOTER //
// ./src/store/modules/user_management/state.js